import type { ReactNode } from 'react';

type FieldProps = {
  label: ReactNode;
  children: ReactNode;
  hint?: ReactNode;
  error?: ReactNode;
  required?: boolean;
  className?: string;
};

export function Field({ label, children, hint, error, required = false, className = '' }: FieldProps) {
  return (
    <label className={`grid gap-1.5 ${className}`}>
      <span className="text-sm font-semibold text-slate-700">
        {label}{required ? <span className="ml-1 text-red-600" aria-hidden="true">*</span> : null}
      </span>
      {children}
      {error ? <span className="text-xs font-medium text-red-600">{error}</span> : hint ? <span className="text-xs text-slate-500">{hint}</span> : null}
    </label>
  );
}

export const inputClassName = 'min-h-10 w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-900 outline-none transition placeholder:text-slate-400 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 disabled:cursor-not-allowed disabled:bg-slate-100';

export default Field;
